const settigns = {
  help: '/api/v1/help/get-help-list',
  createHelp: '/api/v1/help/create-help',
  updateHelp: '/api/v1/help/update-help',
  deleteHelp: '/api/v1/help/delete-help',
  createContent: '/api/v1/content/create-content',
  getContent: '/api/v1/content/get-content-by-type',
  updateContent: '/api/v1/content/update-content',
  getProfile: '/api/v1/profile/get-profile',
  updateProfile: '/api/v1/profile/update-profile',
  changePassword: '/api/v1/auth/change-password',
  sendBroadcast: '/api/v1/broadcast/send-broadcast',
}

export const settignAPIRoutes = {
  ...settigns,
}
